// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'

Vue.config.productionTip = false
Vue.use(VueI18n)

const messages = {
  en: {
    message: {
      title: 'Metal Prices',
      metal: 'Metal',
      time: 'Time',
      buy: 'Bid',
      sell: 'Ask',
      gold: 'Gold',
      silver: 'Silver',
      platinum: 'Platinum',
      palladium: 'Palladium',
      ounce: 'Ounce',
      gram: 'Gram',
      kilogram: 'Kilogram',
      phone: '+33144648020',
      phone_label: '+33 1 44 64 80 20'
    }
  },
  fr: {
    message: {
      title: 'Cours des métaux précieux',
      metal: 'Métal',
      time: 'Heure',
      buy: 'Demande',
      sell: 'Offre',
      gold: 'Or',
      silver: 'Argent',
      platinum: 'Platine',
      palladium: 'Palladium',
      ounce: 'Once',
      gram: 'Gramme',
      kilogram: 'Kilogramme',
      phone: '+33144648020',
      phone_label: '+33 1 44 64 80 20'
    }
  },
  pl: {
    message: {
      title: 'Ceny metali',
      metal: 'Metal',
      time: 'Czas',
      buy: 'Bid',
      sell: 'Ask',
      gold: 'Złoto',
      silver: 'Srebro',
      platinum: 'Platyn',
      palladium: 'Pallad',
      ounce: 'Uncja',
      gram: 'Gram',
      kilogram: 'Kilogram',
      phone: '+33482535699',
      phone_label: '+33 4 82 53 56 99'
    }
  },
  de: {
    message: {
      title: 'Metallpreise',
      metal: 'Metall',
      time: 'Zeit',
      buy: 'Gebot',
      sell: 'Verkauf',
      gold: 'Gold',
      silver: 'Silber',
      platinum: 'Platin',
      palladium: 'Palladium',
      ounce: 'Unze',
      gram: 'Gramm',
      kilogram: 'Kilogramm',
      phone: '+48789236502',
      phone_label: '+48 789 236 502'
    }
  }
}

function getLocale () {
  let userLang = navigator.language || navigator.userLanguage
  userLang = userLang.split('-')[0]
  if (messages[userLang]) {
    return userLang
  }
  return 'en'
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getLocale(), // set locale
  messages: messages // set locale messages
})

const formatter = Intl.NumberFormat('fr')
Vue.filter('formatNumber', formatter.format)

Vue.filter('evolution', value => value < 0 ? value : `+${value}`)

/* eslint-disable no-new */
new Vue({
  i18n: i18n,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js